import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { ReactElement } from 'react';
import { useTranslate } from 'ra-core';

interface RemoveQueryDialogProps {
  open: boolean;
  queryLabel?: string;
  onClose: () => void;
  onRemove: () => void;
}

function RemoveQueryDialog(props: RemoveQueryDialogProps): ReactElement {
  const { open, queryLabel, onClose, onRemove } = props;
  const translate = useTranslate();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        {translate('ra.saved_queries.remove_label_with_name', {
          _: 'Remove query "%{name}"',
          name: queryLabel
        })}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {translate('ra.saved_queries.remove_dialog_text', {
            _: 'Are you sure you want to remove this saved query?'
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} size="small">
          {translate('ra.action.cancel', { _: 'Cancel' })}
        </Button>
        <Button onClick={onRemove} size="small" color="error">
          {translate('ra.action.remove', { _: 'Remove' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export { RemoveQueryDialog };
